import React from 'react';

const servicesData = [
  {
    title: 'Become a global professional',
    img: '/why/1.png',
    description:
      'Organizations around the world have realized the importance of filling their skills gap in order to have an edge over competitors, boost revenue, increase customer satisfaction and accelerate the development of new products and services. In such a scenario, as the demand for skilled professionals becomes more acute, certification holders have an edge.',
  },
  {
    title: 'Stand out from the crowd',
  img: '/why/2.png',
    description:
      'For hiring managers who are inundated by applications for coveted jobs, a professional certification on a resume can help them select the cream of the crop for a particular role. In fact, according to the Talent Shortage Survey, 34 per cent of hiring managers globally have cited a lack of technical competencies as the chief factor contributing to talent shortage. A globally-recognized certification attests to your knowledge and skills and can give you an advantage.',
  },
  {
    title: 'Compete in a global economy',
     img: '/why/3.png',
    description:
      'Certification training and skill upgradation bring you up-to-speed with the latest knowledge in your practice area from a global perspective. With this education, you can benchmark yourself as someone who can apply best practice methodologies to any work scenario and drive mission-critical projects to a successful conclusion anywhere in the world.',
  },
  {
    title: 'Improve productivity and enhance business performance',
   img: '/why/4.png',
    description:
      'By updating you on best practices in your domain and introducing you to a common terminology and methodology for effective teamwork and collaboration, certification training can enable you to enhance your performance at the workplace.',
  },
  {
    title: 'Step up the corporate ladder',
    img: '/why/5.png',
    description:
      'At senior level roles within organizations, holistic understanding of the practice area and domain expertise is expected. As you achieve higher-level certifications and apply that knowledge and skills in your practice area to deliver results, you will be recognized for your specialization and move into leadership roles.',
  },
  {
    title: 'Keep one step ahead of technologies',
    img: '/why/6.png',
    description:
      'For professionals in the IT sector, the demand for skills evolves continually. With the advancement of e-commerce, m-commerce, business intelligence, Big Data and analytics, the requirement for qualified specialists will increase. Accredited certifications in emerging technologies will boost your career scope.',
  },
];

const ServiceCards = () => {
  return (
    <section className="bg-white-100 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-3">Why Choose Ceyone Foundation?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Ceyone’s certification training empowers professionals with global skills, recognition, and growth in a dynamic world.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {servicesData.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow hover:shadow-lg transition duration-300 group"
            >
              <div
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url(${item.img})` }}
              ></div>
              <div className="p-5">
                <h3 className="text-lg font-semibold mb-2 group-hover:text-red-600 transition duration-200">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm group-hover:text-red-400  mb-3">{item.description}</p>
             
              
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
